import React, { useEffect, useRef, useState } from 'react';
import Select from '../../components/select';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  addTotalDistance,
  fetchMeetingType,
  getAutoCategory,
  getCities,
  getCityDistance,
  getExpenseDetail,
  getExpenseTotal,
  getMeetingAllowance,
  getModeOfTransport,
  getSfcFareAndAllowance,
  expenseGeneratorFinalSubmit,
  resetFinalSubmit,
  resetValues,
  resetFinalSubmitErrorMessage,
  setIsSaved,
  setShowUnsavedChangesPopup,
  getOtherExpenseTypeValidate,
} from '../../redux/slice/expenseGenerator';
import ErrorsPopup from '../sfc/ErrorsPopup';
import attachmentIcon from '../../../public/assets/images/attachmentIcon.png';
import { Tooltip } from 'react-tooltip';
import FileAttachedModal from '../../components/modal/FileAttachedModal';
import NoOfCities from '../../components/noOfCities';
import deleteIcon from '../../../public/assets/images/deleteIcon.png';
import closeIcon from '../../../public/assets/images/close.png';
import {
  deleteUploadType,
  getBillUploadType,
  getExpenseBillsDetails,
  resetSubmittedFlags,
  resetUploadBillDelete,
  selectUploadBillAttachment,
  uploadeBill,
} from '../../redux/slice/uploadExpenseBill';
import {
  deleteOtherExpenseType,
  getOtherExpenseType,
  getOtherExpenseTypeList,
  resetOtherExpenseDeleted,
  resetOtherExpenseSubmitted,
  saveOtherExpenseType,
  selectOtherExpenseBillAttachment,
} from '../../redux/slice/otherExpenseBill';
import SuccessfullPopup from '../sfc/SuccessfullPopup';
import ConfirmationPopup from '../sfc/ConfirmationPopup';
import Preview from '../../components/preview';
import leftArrowIcon from '../../../public/assets/images/leftArrowIcon.png';

const INITIAL_VALUES = {
  routes: [
    {
      fromCityName: '',
      toCityName: '',
      fromCityId: 0,
      toCityId: 0,
      distanceEntered: 0,
    },
  ],
  transportName: '',
  transportId: 0,
  categoryName: '',
  categoryId: '',
  totalDistance: null,
  total: 0,
  fare: 0,
  meetingType: 0,
  allowance: 0,
  additionalInfo: '',
  typeOfDeviations: '',
  reasonOfDeviation: '',
};

const getStoredExpenseFormValues = (readfromStore) => {
  return readfromStore ? JSON.parse(
        localStorage.getItem('expenseIdCreated')
      )?.formValuesFromLocal : {...INITIAL_VALUES};
}

const validateUploadBillForm = ({ uploadType, imagePdfDetails }) => {
  const errors = {};
  if (!uploadType) errors.uploadType = 'Please select';
  if (!imagePdfDetails || Object.keys(imagePdfDetails).length === 0) {
    errors.imagePdfDetails = 'Please upload file';
  }
  const isValid = Object.keys(errors).length === 0;
  return [isValid, errors];
};

const validateOtherExpense = ({
  otherExpenseuploadType,
  value,
  imagePdfOtherExpenseDetails,
}) => {
  const errors = {};
  if (!otherExpenseuploadType) errors.otherExpenseuploadType = 'Please select';
  if (!value) errors.value = 'Please select';
  if (
    !imagePdfOtherExpenseDetails ||
    Object.keys(imagePdfOtherExpenseDetails).length === 0
  ) {
    errors.imagePdfOtherExpenseDetails = 'Please upload file';
  }
  const isValid = Object.keys(errors).length === 0;
  return [isValid, errors];
};

const tableHeader = ['Expense Type', 'Value', 'Uploaded File', 'Action'];
const tableHeaderValues = [
  'File Uploaded Type',
  'Uploaded File',
  'Description',
  'Action',
];

const ExpenseCreation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { state , pathname } = useLocation();
  const [formValues, setFormValues] = useState(getStoredExpenseFormValues(state.isFromAttachedDoc));
  const [isRouteCombination, setIsRouteCombination] = useState(false);
  const [showAttchment, setShowAttchment] = useState(false);
  const [showOtherExpenseAttachment, setShowOtherExpenseAttachment] =
    useState(false);
  const [indexValue, setIndexValue] = useState(null);
  const [pendingDelete, setPendingDelete] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [validationError, setValidationError] = useState({});
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [cityCombination, setCityCombination] = useState(false);
  const [meetingTypeErrorMessage, setMeetingTypeErrorMessage] = useState('');
  const [shouldUpdateAllowance, setShouldUpdateAllowance] = useState(!state.isFromAttachedDoc);
  const [showErrorMessagePopupModal, setShowErrorMessagePopupModal] =
    useState(false);
  const [meetingTypeValidationError, setMeetingTypeValidationError] =
    useState('');

     const [validationErrorForToCity, setValidationErrorForToCity] =
    useState('');
  const [uploadBillImagePdfUrlDetails, setUploadBillImagePdfUrlDetails] =
    useState({
      uploadType: null,
      description: '',
      imagePdfDetails: {},
    });
  const [
    otherExpenseBillImagePdfUrlDetails,
    setOtherExpenseBillImagePdfUrlDetails,
  ] = useState({
    otherExpenseuploadType: null,
    value: '',
    description: '',
    imagePdfOtherExpenseDetails: {},
  });
  const {
    expenseDetailForDay,
    cities,
    cityDistanceDetail,
    modeOfTransport,
    isAutoCategory,
    isTotalDistance,
    isFareAndAllowance,
    isFinalSubmit,
    isExpenseTotal,
    MeetingDataForDropdown,
    isMeetingAllowance,
    isFinalSubmitErrorMessage,
    isSaved,
    showUnsavedChangesPopup,
    isOtherExpenseTypeValidateErrorMessage,
  } = useSelector((state) => state?.expenseGenerator);

  const {
    otherExpenseType,
    isOtherExpenseAttachmentDetails: otherExpenseAttachmentDetails,
    isOtherExpenseTypeSubmitted,
    otherExpenseList,
    isOtherExpenseDeleted,
  } = useSelector((state) => state?.otherExpenseBill);

  const {
    isUploadExpenseBillSubmitted: uploadBillSubmitted,
    isAttachmentDetails: uploadAttachmentDetails,
    isUploadTypeDeleted: uploadBillDeletedSuccessfully,
    expenseBillsDetails,
    billUploadType,
  } = useSelector((state) => state?.uploadExpenseBill);

  useEffect(() => {
    dispatch(getCities());
    dispatch(
      getExpenseDetail({
        activityDate: state?.activityDateFor,
        expenseId: state?.expenseIdFor,
      })
    );
    dispatch(getModeOfTransport());
    dispatch(getBillUploadType());
    dispatch(getOtherExpenseType());
  }, [state]);

  useEffect(() => {
    if (
      expenseDetailForDay &&
      Object.keys(expenseDetailForDay).length > 0 &&
      !state?.fromExpenseCreationPage
    ) {
      setFormValues({
        ...expenseDetailForDay,
        fare: expenseDetailForDay?.fareEntered,
        meetingType: expenseDetailForDay?.meetingTypeId,
        typeOfDeviations: expenseDetailForDay?.typeOfDeviations
          ?.map((d) => d.typeOfDeviation)
          .join(', '),
        reasonOfDeviation: expenseDetailForDay?.reasonOfDeviation,
      });
    }
  }, [expenseDetailForDay]);

  useEffect(() => {
    if (uploadAttachmentDetails) {
      setUploadBillImagePdfUrlDetails((prev) => ({
        ...prev,
        imagePdfDetails: uploadAttachmentDetails,
      }));
    }
    if (otherExpenseAttachmentDetails) {
      setOtherExpenseBillImagePdfUrlDetails((prev) => ({
        ...prev,
        imagePdfOtherExpenseDetails: otherExpenseAttachmentDetails,
      }));
    }
  }, [uploadAttachmentDetails, otherExpenseAttachmentDetails]);

  useEffect(() => {
    if (cityDistanceDetail && cityDistanceDetail[0]?.totalDistance === -1) {
      setIsRouteCombination(true);
      setFormValues((prev) => {
        const routes = [...prev.routes];
        if (routes.length > 0) {
          routes[indexValue] = {
            ...routes[indexValue],
            toCityId: 0,
            distanceEntered: 0,
          };
        }
        return {
          ...prev,
          routes,
        };
      });
      return;
    }
    if (cityDistanceDetail && cityDistanceDetail[0]?.totalDistance !== -1) {
      setFormValues((prev) => {
        const routes = [...prev?.routes];
        if (routes.length > 0) {
          routes[indexValue] = {
            ...routes[indexValue],
            distanceEntered: cityDistanceDetail[0]?.totalDistance,
          };
        }
        return {
          ...prev,
          routes,
        };
      });
    }
  }, [cityDistanceDetail]);

  useEffect(() => {
    if (
      !isRouteCombination &&
      expenseDetailForDay &&
      Object.keys(expenseDetailForDay)?.length > 0
    ) {
      const distance = formValues?.routes?.reduce((a, c) => {
        return a + (c.distanceEntered || 0);
      }, 0);
      setFormValues((prev) => ({ ...prev, totalDistance: distance }));
    }
  }, [formValues?.routes]);


  useEffect(() => {
    if (
      formValues.totalDistance !== null &&
      expenseDetailForDay?.designationId &&
      state?.activityDateFor &&
      formValues?.routes &&
      state?.expenseIdFor
    ) {
      dispatch(
        getAutoCategory({
          activityDateFor: state?.activityDateFor,
          distance: formValues.totalDistance,
          designationId: expenseDetailForDay?.designationId,
          fromCityId: formValues?.routes?.length > 0 ? formValues?.routes[0].fromCityId : 0,
          toCityId: formValues.routes?.length > 0 ?  formValues.routes[formValues?.routes?.length - 1]?.toCityId : 0,
          expenseId: state?.expenseIdFor
        })
      );
    }
  }, [
    formValues?.totalDistance,
    expenseDetailForDay?.designationId,
    formValues?.routes
  ]);

  const onChangeHandler = ({ target: { name, value } }, index) => {
    dispatch(setIsSaved(true));

    if(formValues?.routes?.some((formValue) => Number(formValue?.fromCityId) === Number(formValues?.routes[index]?.fromCityId) && Number(formValue?.toCityId) === Number(value))) {
      setCityCombination(true);
      return
    }

    setFormValues((prev) => {
      if (index !== undefined) {
        if (name === 'fromCityId') {
          return {
            ...prev,
            routes: prev.routes.map((route, i) =>
              i === 0 ? { ...route, fromCityId: value, toCityId: null } : route
            ),
          };
        }

        const routes = prev.routes.map((route, i) =>
          i === index ? { ...route, [name]: value } : route
        );

        if (name === 'toCityId') {
          setIndexValue(index);
          setShouldUpdateAllowance(true)
          dispatch(
            getCityDistance({
              fromCityId: routes[index].fromCityId,
              toCityId: value,
              activityDateFor: state?.activityDateFor,
              expenseIdFor: state?.expenseIdFor,
            })
          );
        }

        return {
          ...prev,
          routes,
          typeOfDeviations:
            'Distance Deviation, Fare Deviation, Allowance Deviation',
        };
      }



      if (name === 'meetingType') {
        // Show configured remark for this meeting type
        const selected = MeetingDataForDropdown.filter(
          (item) => item.typeId === value
        )[0];
        setMeetingTypeErrorMessage(selected?.remark || '');
        // Clear only the validation error when user changes meeting type
        setMeetingTypeValidationError('');
        dispatch(
          getMeetingAllowance({
            expenseId: state?.expenseIdFor,
            activityDate: state?.activityDateFor,
            meetingTypeID: value,
          })
        );

      }

      if (name === 'fare' && prev.categoryName === 'OS') {
        // When category is OS and fare is manually edited, recalculate total
        if (expenseDetailForDay?.activityDate) {
          dispatch(
            getExpenseTotal({
              expenseId: state?.expenseIdFor,
              activityDate: expenseDetailForDay?.activityDate
                ?.split('-')
                ?.reverse()
                ?.join('-'),
              fare: Number(value) || 0,
              allowance: formValues?.allowance || 0,
            })
          );
        }
      }

      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onUploadBillChangeHandler = ({ target: { name, value } }) => {
    dispatch(setIsSaved(true));
    setUploadBillImagePdfUrlDetails((prev) => ({
      ...prev,
      [name]: value,
    }));

    setValidationError({ ...validationError, [name]: '' });
  };

  const onOtherExpenseBillChangeHandler = ({ target: { name, value } }) => {
    dispatch(setIsSaved(true));
    setOtherExpenseBillImagePdfUrlDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
    setValidationError({ ...validationError, [name]: '' });
  };

  const submitUploadBillDetails = () => {
    const [validate, errors] = validateUploadBillForm(
      uploadBillImagePdfUrlDetails
    );
    if (!validate) {
      setValidationError(errors);
      return;
    }
    const fileValue = uploadBillImagePdfUrlDetails?.imagePdfDetails?.fileUrl;
    const isFile = fileValue instanceof File || fileValue instanceof Blob;

    let payload = {
      expenseId: state?.expenseIdFor,
      activityDate: state?.activityDateFor,
      uploadedFileName: uploadAttachmentDetails?.uploadedFileName,
      file: isFile ? fileValue : '',
      fileUrl: isFile ? '' : (fileValue ?? ''),
      billType: billUploadType?.filter(
        (item) =>
          item.billUpload_ID === uploadBillImagePdfUrlDetails?.uploadType
      )[0]?.billUpload_Name,
      description: uploadBillImagePdfUrlDetails?.description,
      billTypeId: billUploadType?.filter(
        (item) =>
          item.billUpload_ID === uploadBillImagePdfUrlDetails?.uploadType
      )[0]?.billUpload_ID,
    };
    dispatch(uploadeBill(payload));
    dispatch(selectUploadBillAttachment({}));
    setUploadBillImagePdfUrlDetails({
      uploadType: null,
      description: '',
      imagePdfDetails: {},
    });
  };

  const submitOtherExpense = async () => {
    const [validate, errors] = validateOtherExpense(
      otherExpenseBillImagePdfUrlDetails
    );
    if (!validate) {
      setValidationError(errors);
      return;
    }

    try {
      const response = await dispatch(
        getOtherExpenseTypeValidate({
          expenseTypeId:
            otherExpenseBillImagePdfUrlDetails?.otherExpenseuploadType,
          amount: Number(otherExpenseBillImagePdfUrlDetails?.value),
        })
      ).unwrap();

      // handle both response shapes
      const data = response?.result ?? response;

      // if isValid is false — stop and show popup
      if (data?.isValid === false) return;

      // isValid is true — continue normal flow
      const fileValue =
        otherExpenseBillImagePdfUrlDetails?.imagePdfOtherExpenseDetails
          ?.fileUrl;
      const isFile = fileValue instanceof File || fileValue instanceof Blob;

      const payload = {
        id: 0,
        expenseId: state?.expenseIdFor,
        otherExpenseId:
          otherExpenseBillImagePdfUrlDetails?.otherExpenseuploadType,
        value: Number(otherExpenseBillImagePdfUrlDetails?.value),
        uploadedFile: isFile ? '' : (fileValue ?? ''),
        file: isFile ? fileValue : '',
        uploadedFileName:
          otherExpenseBillImagePdfUrlDetails?.imagePdfOtherExpenseDetails
            ?.uploadedFileName,
        description: otherExpenseBillImagePdfUrlDetails?.description,
        toEdit: 0,
        otherexpensetypeName: otherExpenseType?.getAllExpense?.filter(
          (item) =>
            item?.otherExpenseTypeId ===
            otherExpenseBillImagePdfUrlDetails?.otherExpenseuploadType
        )[0]?.otherExpenseTypeName,
        activityDate: state?.activityDateFor,
        expenseDetailId: 0,
      };

      dispatch(saveOtherExpenseType(payload));
      dispatch(selectOtherExpenseBillAttachment({}));
      setOtherExpenseBillImagePdfUrlDetails({
        otherExpenseuploadType: null,
        value: '',
        description: '',
        imagePdfOtherExpenseDetails: {},
      });
    } catch (error) {
      setShowErrorMessagePopupModal(true);
      console.error('validation error', error);
    }
  };

  useEffect(() => {
    dispatch(
      getExpenseBillsDetails({
        activityDate: state?.activityDateFor,
        expenseId: state?.expenseIdFor,
      })
    );
    dispatch(resetUploadBillDelete());
  }, [uploadBillSubmitted, uploadBillDeletedSuccessfully]);

  useEffect(() => {
    dispatch(
      getOtherExpenseTypeList({
        expenseId: state?.expenseIdFor,
        activityDate: state?.activityDateFor,
      })
    );

    // if (isFareAndAllowance && Object.keys(isFareAndAllowance).length > 0) {
    //   setFormValues((prev) => ({
    //     ...prev,
    //     fare: isFareAndAllowance?.oneWayFare,
    //   }));
    // }
    dispatch(resetOtherExpenseDeleted());
  }, [isOtherExpenseTypeSubmitted, isOtherExpenseDeleted]);

  useEffect(() => {
    if (
      isAutoCategory?.result &&
      Object.keys(isAutoCategory?.result)?.length > 0
    ) {
      setFormValues((prev) => ({
        ...prev,
        categoryName: isAutoCategory?.result?.cityCategory,
        categoryId: isAutoCategory?.result?.categoryId,
      }));

      if(!state.isFromAttachedDoc || shouldUpdateAllowance) dispatch(
        getSfcFareAndAllowance({
          fromCityId:
            formValues?.routes[formValues?.routes?.length - 1]?.fromCityId,
          toCityId:
            formValues?.routes[formValues?.routes?.length - 1]?.toCityId,
          categoryId: isAutoCategory?.result?.categoryId,
          effectiveDate: expenseDetailForDay?.activityDate,
          expenseId: state?.expenseIdFor,
          totalDistance: formValues?.totalDistance,
        })
      );
    }
  }, [isAutoCategory]);

  useEffect(() => {
    if (expenseDetailForDay?.activityCode === 'MT' || true) {
      dispatch(
        fetchMeetingType({
          expenseId: state?.expenseIdFor,
          activityDate: state?.activityDateFor,
        })
      );
    }
  }, [expenseDetailForDay?.activityCode]);

  useEffect(() => {
    if (isFareAndAllowance && Object.keys(isFareAndAllowance).length > 0) {
      setFormValues((prev) => ({
        ...prev,
        fare: state?.isFromAttachedDoc && !shouldUpdateAllowance
          ? prev.fare
          : isFareAndAllowance?.oneWayFare,
        allowance: isFareAndAllowance?.allowance,
      }));
      // dispatch(
      //   getExpenseTotal({
      //     expenseId: state?.expenseIdFor,
      //     activityDate: expenseDetailForDay?.activityDate
      //       ?.split('-')
      //       ?.reverse()
      //       ?.join('-'),
      //     fare: isFareAndAllowance?.oneWayFare,
      //     allowance: isFareAndAllowance?.allowance,
      //   })
      // );
    }
  }, [isFareAndAllowance]);

  const onFinalSubmitHandler = () => {
    // If meeting type feature is enabled for this activity, it becomes mandatory
    if (
      expenseDetailForDay?.activityCode?.includes('MT') &&
      !formValues?.meetingType
    ) {
      setMeetingTypeValidationError('Please select meeting type');
      return;
    }

    if(!formValues?.routes?.every((item) => item.toCityId)) {
      setValidationErrorForToCity(true);
      return;
    }

    {
      const payload = {
        expenseId: state?.expenseIdFor,
        activityDate: expenseDetailForDay?.activityDate
          ?.split('-')
          ?.reverse()
          ?.join('-'),
        modeEntered: formValues?.transportId,
        fareEntered: formValues?.fare,
        allowancesEntered: formValues?.allowance,
        wayEntered: `${isAutoCategory?.result?.cityCategory === 'OS' || isAutoCategory?.result?.cityCategory === 'HQ' ? 1 : isAutoCategory?.result?.cityCategory === 'Ex' ? 2 : 0}`, // OS and HQ = 1 , ex-HQ = 2 , NO-Category- 0
        travelFromOthers: expenseDetailForDay?.travelFromOthers,
        travelToOthers: expenseDetailForDay?.travelToOthers,
        additionalInfo: formValues?.additionalInfo,
        reasonForDeviation: formValues?.reasonOfDeviation,
        typeOfDeviation: formValues?.typeOfDeviations,
        allowanceBillUploadedFlag:
          expenseDetailForDay?.allowanceBillUploadedFlag,
        allowanceBillFilename: expenseDetailForDay?.allowanceBillFilename,
        fareBillUploadedFlag: expenseDetailForDay?.fareBillUploadedFlag,
        fareBillFilename: expenseDetailForDay?.fareBillFilename,
        metroAllowance: expenseDetailForDay?.metroAllowance,
        hotelBillFilename: expenseDetailForDay?.hotelBillFilename,
        hotelBillUploadedFlag: expenseDetailForDay?.hotelBillUploadedFlag,
        category: formValues?.categoryId, // ID
        total: formValues?.total,
        meetingTypeId: formValues?.meetingType || null,
        meetingType:
          MeetingDataForDropdown?.filter(
            (item) => item.typeId === formValues?.meetingType
          )[0]?.type || '',
        routes: formValues?.routes?.map((items) => {
          return {
            fromCityId: items?.fromCityId,
            toCityId: items?.toCityId,
            distance: items?.distanceEntered,
            expenseDetailId: state?.expenseDetailIdFor,
            fare: expenseDetailForDay?.fareEntered,
            allowance: formValues?.allowance,
            category: formValues?.categoryId,
          };
        }),
      };
      dispatch(expenseGeneratorFinalSubmit(payload));
    }
  };

  useEffect(() => {
    if (isExpenseTotal) {
      setFormValues((prev) => ({
        ...prev,
        total: isExpenseTotal?.result?.total,
      }));
    }
  }, [isExpenseTotal]);

  useEffect(() => {
    if (state?.fromExpenseCreationPage) {
      const getFormValues = JSON.parse(
        localStorage.getItem('expenseIdCreated')
      );
      // setFormValues(getFormValues?.formValuesFromLocal);
      setUploadBillImagePdfUrlDetails((prev) => ({
        ...prev,
        uploadType:
          getFormValues?.uploadBillImagePdfUrlDetailsFromLocal?.uploadType,
        description:
          getFormValues?.uploadBillImagePdfUrlDetailsFromLocal?.description,
      }));
      setOtherExpenseBillImagePdfUrlDetails((prev) => ({
        ...prev,
        otherExpenseuploadType:
          getFormValues?.otherExpenseBillImagePdfUrlDetailsFromLocal
            ?.otherExpenseuploadType,
        description:
          getFormValues?.otherExpenseBillImagePdfUrlDetailsFromLocal
            ?.description,
        value:
          getFormValues?.otherExpenseBillImagePdfUrlDetailsFromLocal?.value,
      }));
      dispatch(setIsSaved(true));
    }
  }, [state?.fromExpenseCreationPage]);

  useEffect(() => {
    if (isMeetingAllowance && Object.keys(isMeetingAllowance)?.length > 0) {
      setFormValues((prev) => ({
        ...prev,
        allowance: isMeetingAllowance?.result?.allowance,
      }));
    }
  }, [isMeetingAllowance]);

  useEffect(() => {
    if (
      formValues?.allowance !== '' &&
      formValues?.fare !== '' &&
      expenseDetailForDay &&
      Object.keys(expenseDetailForDay)?.length > 0
    ) {

      dispatch(
        getExpenseTotal({
          expenseId: state?.expenseIdFor,
          activityDate: expenseDetailForDay?.activityDate
            ?.split('-')
            ?.reverse()
            ?.join('-'),
          fare: formValues?.fare,
          allowance: formValues?.allowance,
        })
      );
    }
  }, [formValues?.allowance, formValues?.fare, isOtherExpenseTypeSubmitted, isOtherExpenseDeleted]);

  const handleBackNavigation = () => {
    if (!params?.expenseDetailId && isSaved) {
      dispatch(setShowUnsavedChangesPopup(true));
      return;
    }

    if (params?.expenseDetailId) {
      navigate(-1);
      return;
    }
    navigate('/my-expense');
  };

  return (
    <div className="">
      {uploadBillSubmitted ? (
        <div className="h-lvh flex justify-center items-center">
          <SuccessfullPopup
            onClose={() => dispatch(resetSubmittedFlags())}
            displayText={'Added'}
          />
        </div>
      ) : null}
      {isOtherExpenseTypeSubmitted ? (
        <div className="h-lvh flex justify-center items-center">
          <SuccessfullPopup
            onClose={() => dispatch(resetOtherExpenseSubmitted())}
            displayText={'Added'}
          />
        </div>
      ) : null}
      {isFinalSubmit ? (
        <div className="h-lvh flex justify-center items-center">
          <SuccessfullPopup
            onClose={() => {
              dispatch(resetFinalSubmit());
              navigate('/my-expense');
            }}
            displayText={'Added'}
          />
        </div>
      ) : null}
      <ErrorsPopup
        show={cityCombination}
        message={`From and To city combination already exists`}
        onClose={() => {
          setCityCombination(false);
        }}
      />
      <ErrorsPopup
        show={validationErrorForToCity}
        message={`Please select to city`}
        onClose={() => {
          setValidationErrorForToCity(false);
        }}
      />
      <ErrorsPopup
        show={isRouteCombination}
        message={`${cityDistanceDetail[0]?.message}`}
        onClose={() => {
          setIsRouteCombination(false);
          dispatch(resetValues());
        }}
      />
      <ErrorsPopup
        show={
          isFinalSubmitErrorMessage &&
          Object.keys(isFinalSubmitErrorMessage).length > 0
        }
        message={isFinalSubmitErrorMessage?.message}
        onClose={() => {
          dispatch(resetFinalSubmitErrorMessage());
        }}
      />

      <ErrorsPopup
        show={showErrorMessagePopupModal}
        message={isOtherExpenseTypeValidateErrorMessage?.message}
        onClose={() => {
          setShowErrorMessagePopupModal(false);
        }}
      />

      <ConfirmationPopup
        message={'Already made changes will be DELETED ?'}
        show={showUnsavedChangesPopup}
        onDenied={() => {
          dispatch(setShowUnsavedChangesPopup(false));
        }}
        onProceed={() => {
          dispatch(setShowUnsavedChangesPopup(false));
          dispatch(setIsSaved(false));
          navigate('/my-expense');
        }}
      />

      <ConfirmationPopup
        message={'Do you want to delete this permanently?'}
        show={showConfirmationPopup}
        onDenied={() => {
          setShowConfirmationPopup(false);
          setPendingDelete(null);
        }}
        onProceed={() => {
          if (pendingDelete?.type === 'UPLOAD_BILL') {
            dispatch(deleteUploadType(pendingDelete?.payload));
          }
          if (pendingDelete?.type === 'OTHER_EXPENSE') {
            dispatch(deleteOtherExpenseType(pendingDelete?.payload));
          }
          setShowConfirmationPopup(false);
          setPendingDelete(null);
        }}
      />

      <Preview
        show={previewUrl}
        url={previewUrl}
        onClose={() => {
          setPreviewUrl(null);
        }}
      />
      <div className="smAndMd:pt-8 lg:pt-16 pl-[24px] px-4 flex flex-col justify-between">
        <div>
          <div className="flex items-center smAndMd:justify-between gap-4 mx-2">
            <img
              src={leftArrowIcon}
              alt="back"
              width={10}
              height={10}
              className="cursor-pointer block lg:hidden"
              onClick={handleBackNavigation}
            />
            <div className="font-semibold text-[#A04D95] text-[22px]">
              Expense
            </div>
            <div></div>
          </div>

          <div className="lg:hidden">
            <div className="text-[#514D4C] text-[14px] font-normal flex py-4 px-2 items-center gap-2">
              Activity Date:
              <p className="relative">
                <input
                  type="date"
                  name=""
                  id=""
                  className="border border-[#514D4C] rounded px-2"
                  value={state?.activityDateFor || ''}
                  disabled
                />
              </p>
            </div>
          </div>

          <div className="flex justify-between items-center border-b border-[#CCCCCC] pb-4 lg:pt-4 mx-2">
            <div className="text-[#514D4C] font-semibold text-[18px]">
              Multi cities
            </div>
            <div className="text-[#514D4C] text-[14px] font-normal">
              {expenseDetailForDay?.activityName}
            </div>
            <div className="hidden lg:block">
              <div className="text-[#514D4C] text-[14px] font-normal flex justify-center items-center gap-2">
                Activity Date:
                <p className="relative">
                  <input
                    type="date"
                    name=""
                    id=""
                    className="border border-[#514D4C] rounded px-2"
                    value={state?.activityDateFor || ''}
                    disabled
                  />
                </p>
              </div>
            </div>
          </div>

          <div className="grid lg:grid-rows-5 gap-2">
            {formValues?.routes?.map((item, index) => {
              return (
                <NoOfCities
                  index={index}
                  item={expenseDetailForDay}
                  onChangeHandler={onChangeHandler}
                  cities={cities}
                  formValues={formValues?.routes[index]}
                  showPlaceholder={params?.expenseDetailId}
                  formValuesLength={formValues?.routes?.length}
                />
              );
            })}

            {params?.expenseDetailId ? null : (
              <div className="flex justify-end items-end gap-4 mx-2">
                <div className="border rounded-full border-[#A04D95] cursor-pointer w-[128px] h-[39px] flex justify-center items-center">
                  <button
                    className="font-medium text-[#A04D95] text-[18px]"
                    onClick={() => {
                      setShouldUpdateAllowance(true);
                      setFormValues((prev) => ({
                        ...prev,
                        routes: [
                          ...prev?.routes,
                          {
                            fromCityName:
                              formValues?.routes[formValues?.routes?.length - 1]
                                ?.toCityName,
                            toCityName: '',
                            fromCityId:
                              formValues?.routes[formValues?.routes?.length - 1]
                                ?.toCityId,
                            toCityId: 0,
                            distanceEntered: '',
                          },
                        ],
                      }));
                    }}
                  >
                    New Row
                  </button>
                </div>
                <div className="border rounded-full border-[#A04D95] cursor-pointer bg-[#A04D95] w-[128px] h-[39px] flex justify-center items-center">
                  <button
                    className="font-medium text-[18px] text-white"
                    onClick={() => {
                      setFormValues((prev) => {
                      setShouldUpdateAllowance(true)
                        const updatedRoutes = prev.routes.slice(0, -1);
                        // Recalculate total distance from remaining routes
                        const newTotalDistance = updatedRoutes.reduce(
                          (sum, route) => {
                            return sum + (route.distanceEntered || 0);
                          },
                          0
                        );
                        // Dispatch to trigger getAutoCategory useEffect
                        // dispatch(addTotalDistance(newTotalDistance));
                        return {
                          ...prev,
                          totalDistance: newTotalDistance,
                          routes: updatedRoutes,
                        };
                      });
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            )}

            <div className="grid md:grid-cols-3">
              <Select
                disabled={params?.expenseDetailId}
                options={modeOfTransport}
                label={'Select Mode'}
                labelAttri={'transportName'}
                valueAttri={'transportId'}
                onChange={onChangeHandler}
                value={formValues?.transportId}
                name={'transportId'}
                //   error={errors.toCityId}
              />

              <div className="relative h-12 mt-3 mx-2">
                <input
                  name="totalDistance"
                  type="text"
                  value={formValues?.totalDistance}
                  className="cursor-not-allowed bg-gray-100 peer h-12 leading-none flex items-center text-secondary font-medium text-baseMd border border-[#AAAAAA] focus:outline-none rounded px-3 pt-4 pb-2 w-full" /* pt-6 pb-2 + flex centers value; leading-none prevents extra line-height */
                  placeholder=" "
                  id="category-input"
                  disabled
                />
                <label
                  htmlFor="category-input"
                  className="absolute left-3 pointer-events-none bg-white px-1 text-sm text-[#AAAAAA] transition-all duration-200 ease-in-out
      peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-base peer-placeholder-shown:-translate-y-1/2
      peer-focus:top-0 peer-focus:text-sm peer-focus:translate-y-0 peer-focus:scale-75
      peer-not-placeholder-shown:top-0 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:translate-y-0 peer-not-placeholder-shown:scale-75"
                >
                  Total Distance
                </label>
              </div>

              <div className="relative h-12 mt-3 mx-2">
                <input
                  name="fare"
                  type="number"
                  value={formValues?.fare}
                  onChange={onChangeHandler}
                  className={`${formValues?.categoryName !== 'OS' ? 'cursor-not-allowed bg-gray-100' : ''} peer h-12 leading-none flex items-center text-secondary font-medium text-baseMd border border-[#AAAAAA] focus:outline-none rounded px-3 pt-4 pb-2 w-full`} /* pt-6 pb-2 + flex centers value; leading-none prevents extra line-height */
                  placeholder=" "
                  id="category-input"
                  disabled={formValues?.categoryName !== 'OS' ||  params?.expenseDetailId}
                />
                <label
                  htmlFor="category-input"
                  className="absolute left-3 pointer-events-none bg-white px-1 text-sm text-[#AAAAAA] transition-all duration-200 ease-in-out
      peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-base peer-placeholder-shown:-translate-y-1/2
      peer-focus:top-0 peer-focus:text-sm peer-focus:translate-y-0 peer-focus:scale-75
      peer-not-placeholder-shown:top-0 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:translate-y-0 peer-not-placeholder-shown:scale-75"
                >
                  Fare
                </label>
              </div>
            </div>

            <div className="grid md:grid-cols-3">
              <div className="relative h-12 mt-3 mx-2">
                <input
                  name="allowance"
                  type="text"
                  value={formValues?.allowance}
                  className="cursor-not-allowed bg-gray-100 peer h-12 leading-none flex items-center text-secondary font-medium text-baseMd border border-[#AAAAAA] focus:outline-none rounded px-3 pt-4 pb-2 w-full" /* pt-6 pb-2 + flex centers value; leading-none prevents extra line-height */
                  placeholder=" "
                  id="category-input"
                  disabled
                />
                <label
                  htmlFor="category-input"
                  className="absolute left-3 pointer-events-none bg-white px-1 text-sm text-[#AAAAAA] transition-all duration-200 ease-in-out
      peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-base peer-placeholder-shown:-translate-y-1/2
      peer-focus:top-0 peer-focus:text-sm peer-focus:translate-y-0 peer-focus:scale-75
      peer-not-placeholder-shown:top-0 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:translate-y-0 peer-not-placeholder-shown:scale-75"
                >
                  Allowance
                </label>
              </div>

              <div className="relative h-12 mt-3 mx-2">
                <input
                  name="category"
                  type="text"
                  value={formValues?.categoryName}
                  className="cursor-not-allowed bg-gray-100 peer h-12 leading-none flex items-center text-secondary font-medium text-baseMd border border-[#AAAAAA] focus:outline-none rounded px-3 pt-4 pb-2 w-full" /* pt-6 pb-2 + flex centers value; leading-none prevents extra line-height */
                  placeholder=" "
                  id="category-input"
                  disabled
                />
                <label
                  htmlFor="category-input"
                  className="absolute left-3 pointer-events-none bg-white px-1 text-sm text-[#AAAAAA] transition-all duration-200 ease-in-out
      peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-base peer-placeholder-shown:-translate-y-1/2
      peer-focus:top-0 peer-focus:text-sm peer-focus:translate-y-0 peer-focus:scale-75
      peer-not-placeholder-shown:top-0 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:translate-y-0 peer-not-placeholder-shown:scale-75"
                >
                  Category
                </label>
              </div>

              {expenseDetailForDay?.activityCode?.includes('MT') ||
              expenseDetailForDay?.activityCode?.includes('TR') ? (
                <div className="flex flex-col">
                  <Select
                    options={MeetingDataForDropdown}
                    label={'Meeting Type'}
                    labelAttri={'type'}
                    valueAttri={'typeId'}
                    onChange={onChangeHandler}
                    value={formValues?.meetingType}
                    name={'meetingType'}
                  />
                  {meetingTypeValidationError ? (
                    <p className="px-3 pt-1 text-xs text-red-600">
                      {meetingTypeValidationError}
                    </p>
                  ) : null}
                  {meetingTypeErrorMessage ? (
                    <p className="p-3 text-xs text-red-600">
                      {meetingTypeErrorMessage}
                    </p>
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>

          <div className="">
            <div className="border-b border-[#CCCCCC] pb-4 pt-4 mx-2 flex justify-between">
              <div className="text-[#514D4C] font-semibold text-[18px]">
                Upload Bill
              </div>
              <div className="flex gap-2">
                {uploadBillImagePdfUrlDetails?.imagePdfDetails
                  ?.uploadedFileName ? (
                  <a className="text-[14px] text-[#A04D95] hover:underline">
                    {
                      uploadBillImagePdfUrlDetails?.imagePdfDetails
                        ?.uploadedFileName
                    }
                  </a>
                ) : (
                  <a className="text-[14px] text-[#514D4CCC]">
                    Click to Attach
                  </a>
                )}
                {validationError?.imagePdfDetails ? (
                  <p className="text-red-600 mx-2 pl-2">
                    {validationError?.imagePdfDetails}
                  </p>
                ) : null}
                {params?.expenseDetailId ? null : (
                  <div
                    data-tooltip-id="attach"
                    data-tooltip-content="Attach receipts /bills"
                    data-tooltip-place="bottom"
                    className="cursor-pointer relative"
                    onClick={() => {
                      localStorage.setItem(
                        'expenseIdCreated',
                        JSON.stringify({
                          expenseIdFor: state?.expenseIdFor,
                          activityDateFor: state?.activityDateFor,
                          expenseDetailIdFor: state?.expenseDetailIdFor,
                          type: 'UPLOAD_BILL',
                          fromExpenseCreationPage: true,
                          formValuesFromLocal: formValues,
                          uploadBillImagePdfUrlDetailsFromLocal: {
                            uploadType:
                              uploadBillImagePdfUrlDetails?.uploadType,
                            description:
                              uploadBillImagePdfUrlDetails?.description,
                          },
                          otherExpenseBillImagePdfUrlDetailsFromLocal: {
                            otherExpenseuploadType:
                              otherExpenseBillImagePdfUrlDetails?.otherExpenseuploadType,
                            value: otherExpenseBillImagePdfUrlDetails?.value,
                            description:
                              otherExpenseBillImagePdfUrlDetails?.description,
                          },
                        })
                      );
                      setShowAttchment(!showAttchment);
                    }}
                  >
                    <FileAttachedModal
                      onClose={() => {}}
                      showModal={showAttchment}
                      onClick={() => {
                        setShowAttchment(!showAttchment);
                      }}
                      type={'HOSPITAL_SURVEY_EXPENSE'}
                    />{' '}
                    <img
                      src={attachmentIcon}
                      alt="attachmentIcon"
                      height={'20px'}
                      width={'20px'}
                    />
                    <Tooltip id="attach" className="!text-xs" />
                  </div>
                )}
                {uploadBillImagePdfUrlDetails?.imagePdfDetails
                  ?.uploadedFileName ? (
                  <p
                    onClick={() => {
                      dispatch(selectUploadBillAttachment({}));
                    }}
                  >
                    <img
                      src={closeIcon}
                      alt="cancel"
                      height={20}
                      width={20}
                      className="cursor-pointer"
                    />
                  </p>
                ) : null}
              </div>
            </div>

            <div className="grid grid-rows-2">
              <div className="grid md:grid-cols-3">
                <Select
                  options={billUploadType}
                  label={'Upload Type'}
                  labelAttri={'billUpload_Name'}
                  valueAttri={'billUpload_ID'}
                  onChange={onUploadBillChangeHandler}
                  value={uploadBillImagePdfUrlDetails?.uploadType}
                  name={'uploadType'}
                  error={validationError?.uploadType}
                />

                <input
                  onChange={onUploadBillChangeHandler}
                  name="description"
                  type="text"
                  value={uploadBillImagePdfUrlDetails?.description}
                  className="text-secondary font-medium text-baseMd border border-[#AAAAAA] mt-3 mx-2 focus:outline-none rounded h-12 p-2"
                  placeholder="Description"
                />
              </div>
              {params?.expenseDetailId ? null : (
                <div className="flex justify-end items-center mx-2">
                  <button
                    className="border rounded-full border-[#A04D95] cursor-pointer w-[128px] h-[39px] font-medium text-[#A04D95] text-[18px]"
                    onClick={submitUploadBillDetails}
                  >
                    Upload
                  </button>
                </div>
              )}
            </div>

            <div className="mx-2">
              {/* Mobile: card list (prevents text overlap) */}
              <div className="md:hidden">
                {expenseBillsDetails?.result?.length > 0 ? (
                  <div className="space-y-3">
                    {expenseBillsDetails?.result?.map((item, index) => (
                      <div
                        key={item?.billUploadId ?? index}
                        className="border border-[#CCCCCC] rounded-md bg-white p-3"
                      >
                        <div className="grid grid-cols-2 gap-x-3 gap-y-2 text-[12px]">
                          <div className="text-[#514D4C] font-semibold">
                            File Uploaded Type
                          </div>
                          <div className="text-[#514D4C] break-words">
                            {item.billType || '-'}
                          </div>

                          <div className="text-[#514D4C] font-semibold">
                            Uploaded File
                          </div>
                          <button
                            type="button"
                            className="text-left text-[#A04D95] font-medium hover:underline break-words"
                            onClick={() => setPreviewUrl(item?.fileUrl)}
                          >
                            {item.uploadedFileName || '-'}
                          </button>

                          <div className="text-[#514D4C] font-semibold">
                            Description
                          </div>
                          <div className="text-[#514D4C] break-words">
                            {item.description || '-'}
                          </div>
                        </div>

                        <div className="mt-3 flex justify-end">
                          <button
                            type="button"
                            className={`p-2 ${params?.expenseDetailId ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
                            disabled={!!params?.expenseDetailId}
                            onClick={() => {
                              if (params?.expenseDetailId) return;
                              setPendingDelete({
                                type: 'UPLOAD_BILL',
                                payload: item?.billUploadId,
                              });
                              setShowConfirmationPopup(true);
                            }}
                          >
                            <img
                              src={deleteIcon}
                              alt="delete"
                              height={16.6}
                              width={15}
                            />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>

              {/* Desktop/tablet: keep existing table layout */}
              <div className="hidden md:block">
                {expenseBillsDetails?.result?.length > 0 ? (
                  <div className="grid grid-cols-4 bg-[#EEEEEE] rounded-t-sm border border-[#CCCCCC] h-[45px] flex items-center">
                    {tableHeaderValues?.map((header, index) => {
                      return (
                        <div
                          key={index}
                          className={`text-[#514D4C] font-medium text-sm text-center  ${
                            header !== 'File Uploaded Type'
                              ? 'border-l-[#B3B3B3] border-l-[0.5px]'
                              : null
                          }`}
                        >
                          {header}
                        </div>
                      );
                    })}
                  </div>
                ) : null}

                <div className="grid grid-cols-4 rounded-b-sm border border-t-0 border-[#CCCCCC]">
                  <div className="">
                    {expenseBillsDetails?.result?.map((item, index) => {
                      return (
                        <div
                          key={item?.billUploadId ?? index}
                          className="h-[37px] border-b-1 border-b-[#CCCCCC] flex items-center justify-center text-[#514D4C] text-xs font-medium"
                        >
                          {item.billType}
                        </div>
                      );
                    })}
                  </div>
                  <div>
                    {expenseBillsDetails?.result?.map((item, index) => {
                      return (
                        <div
                          key={item?.billUploadId ?? index}
                          className="h-[37px] border-b-1 border-b-[#CCCCCC] flex items-center justify-center text-[#A04D95] text-xs font-medium hover:underline cursor-pointer px-2 truncate"
                          title={item.uploadedFileName}
                          onClick={() => {
                            setPreviewUrl(item?.fileUrl);
                          }}
                        >
                          {item.uploadedFileName}
                        </div>
                      );
                    })}
                  </div>
                  <div>
                    {expenseBillsDetails?.result?.map((item, index) => {
                      return (
                        <div
                          key={item?.billUploadId ?? index}
                          className="h-[37px] border-b-1 border-b-[#CCCCCC] flex items-center justify-center text-[#514D4C] text-xs font-medium px-2 truncate"
                          title={item.description}
                        >
                          {item.description}
                        </div>
                      );
                    })}
                  </div>
                  <div>
                    {expenseBillsDetails?.result?.map((item, index) => {
                      return (
                        <div
                          key={item?.billUploadId ?? index}
                          className="h-[37px] border-b-1 border-b-[#CCCCCC] flex items-center justify-center text-[#514D4C] text-xs font-medium"
                        >
                          <img
                            className={`${params?.expenseDetailId ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                            src={deleteIcon}
                            alt=""
                            height={16.6}
                            width={15}
                            onClick={() => {
                              if (params?.expenseDetailId) {
                                return null;
                              } else {
                                setPendingDelete({
                                  type: 'UPLOAD_BILL',
                                  payload: item?.billUploadId,
                                });
                                setShowConfirmationPopup(true);
                              }
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="border-b border-[#CCCCCC] pb-4 pt-4 mx-2 flex justify-between">
              <div className="text-[#514D4C] font-semibold text-[18px]">
                Other Expenses
              </div>
              <div className="flex gap-2">
                {otherExpenseBillImagePdfUrlDetails?.imagePdfOtherExpenseDetails
                  ?.uploadedFileName ? (
                  <a className="text-[14px] text-[#A04D95] hover:underline">
                    {
                      otherExpenseBillImagePdfUrlDetails
                        ?.imagePdfOtherExpenseDetails?.uploadedFileName
                    }
                  </a>
                ) : (
                  <a className="text-[14px] text-[#514D4CCC]">
                    Click to Attach
                  </a>
                )}
                {validationError?.imagePdfOtherExpenseDetails ? (
                  <p className="text-red-600 mx-2 pl-2">
                    {validationError?.imagePdfOtherExpenseDetails}
                  </p>
                ) : null}
                {params?.expenseDetailId ? null : (
                  <div
                    data-tooltip-id="attach"
                    data-tooltip-content="Attach receipts /bills"
                    data-tooltip-place="bottom"
                    className="cursor-pointer relative"
                    onClick={() => {
                      localStorage.setItem(
                        'expenseIdCreated',
                        JSON.stringify({
                          expenseIdFor: state?.expenseIdFor,
                          activityDateFor: state?.activityDateFor,
                          expenseDetailIdFor: state?.expenseDetailIdFor,
                          type: 'OTHER_EXPENSE_BILL',
                          fromExpenseCreationPage: true,
                          formValuesFromLocal: formValues,
                          uploadBillImagePdfUrlDetailsFromLocal:
                            uploadBillImagePdfUrlDetails,
                          otherExpenseBillImagePdfUrlDetailsFromLocal:
                            otherExpenseBillImagePdfUrlDetails,
                        })
                      );
                      setShowOtherExpenseAttachment(
                        !showOtherExpenseAttachment
                      );
                    }}
                  >
                    <FileAttachedModal
                      onClose={() => {}}
                      showModal={showOtherExpenseAttachment}
                      onClick={() => {
                        setShowOtherExpenseAttachment(
                          !showOtherExpenseAttachment
                        );
                      }}
                      type={'HOSPITAL_SURVEY_EXPENSE'}
                    />{' '}
                    <img
                      src={attachmentIcon}
                      alt="attachmentIcon"
                      height={'20px'}
                      width={'20px'}
                    />
                    <Tooltip id="attach" className="!text-xs" />
                  </div>
                )}
                {otherExpenseBillImagePdfUrlDetails?.imagePdfOtherExpenseDetails
                  ?.uploadedFileName ? (
                  <p
                    onClick={() => {
                      dispatch(selectOtherExpenseBillAttachment({}));
                    }}
                  >
                    <img
                      src={closeIcon}
                      alt="cancel"
                      height={20}
                      width={20}
                      className="cursor-pointer"
                    />
                  </p>
                ) : null}
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <div className="grid md:grid-cols-3 gap-2">
                <Select
                  options={otherExpenseType?.getAllExpense}
                  label={'Select Expense Type'}
                  labelAttri={'otherExpenseTypeName'}
                  valueAttri={'otherExpenseTypeId'}
                  onChange={onOtherExpenseBillChangeHandler}
                  value={
                    otherExpenseBillImagePdfUrlDetails?.otherExpenseuploadType
                  }
                  name={'otherExpenseuploadType'}
                  error={validationError?.otherExpenseuploadType}
                />
                <input
                  onChange={(e) => {
                    if (/^\d{0,5}$/.test(e.target.value)) {
                      onOtherExpenseBillChangeHandler(e);
                    }
                  }}
                  name="value"
                  type="number"
                  value={otherExpenseBillImagePdfUrlDetails?.value}
                  className={`${validationError?.value ? 'border-red-700 form-error placeholder-red-500' : null}  font-medium text-baseMd border border-[#AAAAAA] mt-2 md:mt-3 mx-2 md:mx-0 focus:outline-none rounded h-12 p-2`}
                  placeholder="Value"
                />

                {validationError?.value ? (
                  <p className="text-red-600 mx-2 pl-2">
                    {validationError?.value}
                  </p>
                ) : null}

                <input
                  onChange={onOtherExpenseBillChangeHandler}
                  name="description"
                  type="text"
                  value={otherExpenseBillImagePdfUrlDetails?.description}
                  className="text-secondary font-medium text-baseMd border border-[#AAAAAA] mt-2 md:mt-3 mx-2 focus:outline-none rounded h-12 p-2"
                  placeholder="Description"
                />
              </div>
              {params?.expenseDetailId ? null : (
                <div className="flex justify-end items-center mx-2 mt-1 pb-2 md:mt-0">
                  <button
                    className="border rounded-full border-[#A04D95] cursor-pointer w-[128px] h-[39px] font-medium text-[#A04D95] text-[18px]"
                    onClick={submitOtherExpense}
                  >
                    Add
                  </button>
                </div>
              )}
            </div>

            <div className="mx-2">
              {/* Mobile: card list (prevents text overlap) */}
              <div className="md:hidden">
                {otherExpenseList?.result?.length > 0 ? (
                  <div className="space-y-3">
                    {otherExpenseList?.result?.map((item, index) => (
                      <div
                        key={item?.id ?? index}
                        className="border border-[#CCCCCC] rounded-md bg-white p-3"
                      >
                        <div className="grid grid-cols-2 gap-x-3 gap-y-2 text-[12px]">
                          <div className="text-[#514D4C] font-semibold">
                            Expense Type
                          </div>
                          <div className="text-[#514D4C] break-words">
                            {item.expenseName || '-'}
                          </div>

                          <div className="text-[#514D4C] font-semibold">
                            Value
                          </div>
                          <div className="text-[#514D4C] break-words">
                            {item.enteredValue ?? '-'}
                          </div>

                          <div className="text-[#514D4C] font-semibold">
                            Uploaded File
                          </div>
                          <button
                            type="button"
                            className="text-left text-[#A04D95] font-medium hover:underline break-words"
                            onClick={() => setPreviewUrl(item?.fileUrl)}
                          >
                            {item.uploadedFileName || '-'}
                          </button>
                        </div>

                        <div className="mt-3 flex justify-end">
                          <button
                            type="button"
                            className={`p-2 ${params?.expenseDetailId ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
                            disabled={!!params?.expenseDetailId}
                            onClick={() => {
                              if (params?.expenseDetailId) return;
                              setPendingDelete({
                                type: 'OTHER_EXPENSE',
                                payload: {
                                  id: item?.id,
                                  expenseId: item?.expenseId,
                                  activityDate: item?.activityDate,
                                },
                              });
                              setShowConfirmationPopup(true);
                            }}
                          >
                            <img
                              src={deleteIcon}
                              alt="delete"
                              height={16.6}
                              width={15}
                            />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>

              {/* Desktop/tablet: keep existing table layout */}
              <div className="hidden md:block">
                {otherExpenseList?.result?.length > 0 ? (
                  <div className="grid grid-cols-4 bg-[#EEEEEE] rounded-t-sm border border-[#CCCCCC] h-[45px] flex items-center">
                    {tableHeader?.map((header, index) => {
                      return (
                        <div
                          key={index}
                          className={`text-[#514D4C] font-medium text-sm text-center  ${
                            header !== 'Expense Type'
                              ? 'border-l-[#B3B3B3] border-l-[0.5px]'
                              : null
                          }`}
                        >
                          {header}
                        </div>
                      );
                    })}
                  </div>
                ) : null}
                <div className="grid grid-cols-4 rounded-b-sm border border-t-0 border-[#CCCCCC]">
                  <div className="">
                    {otherExpenseList?.result?.map((item, index) => {
                      return (
                        <div
                          key={item?.id ?? index}
                          className="h-[37px] border-b-1 border-b-[#CCCCCC] flex items-center justify-center text-[#514D4C] text-xs font-medium px-2 truncate"
                          title={item.expenseName}
                        >
                          {item.expenseName}
                        </div>
                      );
                    })}
                  </div>
                  <div>
                    {otherExpenseList?.result?.map((item, index) => {
                      return (
                        <div
                          key={item?.id ?? index}
                          className="h-[37px] border-b-1 border-b-[#CCCCCC] flex items-center justify-center text-[#514D4C] text-xs font-medium px-2 truncate"
                          title={String(item.enteredValue ?? '')}
                        >
                          {item.enteredValue}
                        </div>
                      );
                    })}
                  </div>
                  <div>
                    {otherExpenseList?.result?.map((item, index) => {
                      return (
                        <div
                          key={item?.id ?? index}
                          className="h-[37px] border-b-1 border-b-[#CCCCCC] flex items-center justify-center text-[#A04D95] text-xs font-medium hover:underline cursor-pointer px-2 truncate"
                          title={item.uploadedFileName}
                          onClick={() => {
                            setPreviewUrl(item?.fileUrl);
                          }}
                        >
                          {item.uploadedFileName}
                        </div>
                      );
                    })}
                  </div>
                  <div>
                    {otherExpenseList?.result?.map((item, index) => {
                      return (
                        <div
                          key={item?.id ?? index}
                          className={`h-[37px] border-b-1 border-b-[#CCCCCC] flex items-center justify-center text-[#514D4C] text-xs font-medium ${params?.expenseDetailId ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        >
                          <img
                            src={deleteIcon}
                            alt=""
                            height={16.6}
                            width={15}
                            onClick={() => {
                              if (params?.expenseDetailId) {
                                return null;
                              } else {
                                setPendingDelete({
                                  type: 'OTHER_EXPENSE',
                                  payload: {
                                    id: item?.id,
                                    expenseId: item?.expenseId,
                                    activityDate: item?.activityDate,
                                  },
                                });
                                setShowConfirmationPopup(true);
                              }
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="grid md:grid-cols-3">
                <div className="relative h-12 mt-3 mx-2">
                  <input
                    name="total"
                    type="text"
                    value={formValues?.total}
                    className="cursor-not-allowed bg-gray-100 peer h-12 leading-none flex items-center text-secondary font-medium text-baseMd border border-[#AAAAAA] focus:outline-none rounded px-3 pt-4 pb-2 w-full" /* pt-6 pb-2 + flex centers value; leading-none prevents extra line-height */
                    placeholder=" "
                    id="category-input"
                    disabled
                  />
                  <label
                    htmlFor="category-input"
                    className="absolute left-3 pointer-events-none bg-white px-1 text-sm text-[#AAAAAA] transition-all duration-200 ease-in-out
      peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-base peer-placeholder-shown:-translate-y-1/2
      peer-focus:top-0 peer-focus:text-sm peer-focus:translate-y-0 peer-focus:scale-75
      peer-not-placeholder-shown:top-0 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:translate-y-0 peer-not-placeholder-shown:scale-75"
                  >
                    Total
                  </label>
                </div>

                <div className="relative h-12 mt-3 mx-2">
                  <input
                    name="typeOfDeviation"
                    type="text"
                    value={formValues?.typeOfDeviations}
                    className="cursor-not-allowed bg-gray-100 peer h-12 leading-none flex items-center text-secondary font-medium text-baseMd border border-[#AAAAAA] focus:outline-none rounded px-3 pt-4 pb-2 w-full" /* pt-6 pb-2 + flex centers value; leading-none prevents extra line-height */
                    placeholder=" "
                    id="category-input"
                    disabled
                    data-tooltip-id="attach"
                    data-tooltip-content={`${formValues?.typeOfDeviations}`}
                  />
                  <label
                    htmlFor="category-input"
                    className="absolute left-3 pointer-events-none bg-white px-1 text-sm text-[#AAAAAA] transition-all duration-200 ease-in-out
      peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-base peer-placeholder-shown:-translate-y-1/2
      peer-focus:top-0 peer-focus:text-sm peer-focus:translate-y-0 peer-focus:scale-75
      peer-not-placeholder-shown:top-0 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:translate-y-0 peer-not-placeholder-shown:scale-75"
                  >
                    Type Of Deviation
                  </label>
                  <Tooltip id="attach" className="!text-xs" />
                </div>

                <div className="relative h-12 mt-3 mx-2">
                  <input
                    name="reasonOfDeviation"
                    type="text"
                    value={formValues?.reasonOfDeviation}
                    className="peer h-12 leading-none flex items-center text-secondary font-medium text-baseMd border border-[#AAAAAA] focus:outline-none rounded px-3 pt-4 pb-2 w-full" /* pt-6 pb-2 + flex centers value; leading-none prevents extra line-height */
                    placeholder=" "
                    id="category-input"
                    onChange={onChangeHandler}
                    disabled={params?.expenseDetailId}
                  />
                  <label
                    htmlFor="category-input"
                    className="absolute left-3 pointer-events-none bg-white px-1 text-sm text-[#AAAAAA] transition-all duration-200 ease-in-out
      peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-base peer-placeholder-shown:-translate-y-1/2
      peer-focus:-top-2 peer-focus:text-sm peer-focus:translate-y-0 peer-focus:scale-75
      peer-not-placeholder-shown:-top-2 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:translate-y-0 peer-not-placeholder-shown:scale-75"
                  >
                    Reason For Deviation
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="text-[#514D4C] font-semibold text-[18px] border-b border-[#CCCCCC] pb-4 pt-4 mx-2">
              Additional Information
            </div>
            <div className="flex flex-col gap-2 p-4">
              <input
                onChange={onChangeHandler}
                name="additionalInfo"
                type="text"
                value={formValues?.additionalInfo}
                className="w-full text-[#514D4C] text-baseMd border border-[#AAAAAA] focus:outline-none rounded h-10 p-2"
                placeholder="Please Give AdditionalInfo"
              />
            </div>
          </div>
        </div>

        <div className="flex justify-end items-center gap-4 p-4 border-t border-[#CCCCCC] mx-2">
          <div
            className="border-2 rounded-full border-[#A04D95] cursor-pointer w-[164px] h-[50px] flex justify-center items-center"
            onClick={handleBackNavigation}
          >
            <button className="font-bold text-[#A04D95] text-[18px]">
              Back
            </button>
          </div>
          {params?.expenseDetailId ? null : (
            <div className="border rounded-full border-[#A04D95] cursor-pointer bg-[#A04D95] w-[164px] h-[50px] flex justify-center items-center">
              <button
                className="font-bold text-[18px] text-white"
                onClick={onFinalSubmitHandler}
              >
                Submit
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpenseCreation;
